import { render, staticRenderFns } from "./ZapmailBuyDomain.vue?vue&type=template&id=1c3c48b2"
import script from "./ZapmailBuyDomain.vue?vue&type=script&lang=js"
export * from "./ZapmailBuyDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports